// extracted by css-extract-rspack-plugin
export default {"QueryEditorContainer":"DatasetQueryEditor-module__QueryEditorContainer___e8ksO","isHidden":"DatasetQueryEditor-module__isHidden___tMbnp"};